import { Type } from 'class-transformer';
import { IsBoolean, IsDate, IsOptional, IsString } from 'class-validator';
import { BaseDto } from '../../@base';
import { UserId, UserSessionId } from '../../types';

export class UserSessionClientSummaryDto {
  @IsString()
  ip!: string;

  @IsString()
  location!: string;

  @IsOptional()
  @IsString()
  countryCode?: string;

  @IsString()
  browser!: string;

  @IsString()
  os!: string;

  @IsString()
  device!: string;
}

export class UserSessionSummaryAdminDto extends BaseDto<UserSessionId> {
  @IsString()
  user!: UserId;

  @IsOptional()
  @IsString()
  impersonatedBy?: UserId;

  @IsOptional()
  @IsString()
  sid?: string;

  @IsString()
  clientId!: string;

  @IsBoolean()
  revoked!: boolean;

  @IsOptional()
  @IsDate()
  revokedAt?: Date;

  @IsDate()
  expiresAt!: Date;

  @IsDate()
  lastLoginAt!: Date;

  @Type(() => UserSessionClientSummaryDto)
  client?: UserSessionClientSummaryDto;
}
